import script from "./TitleBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleBar.vue?vue&type=script&lang=ts&setup=true"

import "./TitleBar.vue?vue&type=style&index=0&id=f2711856&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2711856"]])

export default __exports__